// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__1Dn6V","left_component":"Overview_left_component__2wJff","right_component":"Overview_right_component__1E3dk"};